<template>
	<table class="[&_tr+tr>th]:pt-2 [&_tr+tr>td]:pt-2">
		<tbody>
			<tr>
				<th scope="row" class="w-7/12 text-left align-top font-normal">
					<span class="flex gap-2 items-center">
						<NuxtIcon name="clock" filled class="text-icon-primary max-md:hidden" />
						Zákaznická péče
					</span>
				</th>
				<td class="pl-4 whitespace-nowrap align-top">
					Po - Ne
				</td>
				<td class="text-right pl-3 whitespace-nowrap align-top">
					7:00 - 21:00
				</td>
			</tr>
			<tr>
				<th scope="row" class="w-7/12 text-left align-top font-normal">
					<span class="flex gap-2 items-center">
						<NuxtIcon name="custom/phone-stroke" filled class="text-icon-primary max-md:hidden" />
						Bezplatná infolinka:
					</span>
				</th>
				<td colspan="2" class="pl-4 whitespace-nowrap align-top">
					<a :href="`tel:${tel.replace(/ /g,'')}`" @click="trackLinkClickEvent">{{ tel }}</a>
				</td>
			</tr>
			<tr>
				<th scope="row" class="w-7/12 text-left align-top font-normal">
					<span class="flex gap-2 items-center">
						<NuxtIcon name="mail" filled class="text-icon-primary max-md:hidden" />
						Pošlete nám e-mail:
					</span>
				</th>
				<td colspan="2" class="pl-4 whitespace-nowrap align-top">
					<a :href="`mailto:${email}`" @click="trackLinkClickEvent">{{ email }}</a>
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script setup lang="ts">
	import {tel, email} from '@/resources';
	import {trackLinkClickEvent} from '~/utils/tracking';
</script>
